import { render, staticRenderFns } from "./PfDashboard.vue?vue&type=template&id=3ef82eaa&scoped=true"
import script from "./PfDashboard.vue?vue&type=script&lang=js"
export * from "./PfDashboard.vue?vue&type=script&lang=js"
import style0 from "./PfDashboard.vue?vue&type=style&index=0&id=3ef82eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef82eaa",
  null
  
)

export default component.exports